import { ReactNode, useContext, useEffect } from 'react';

import { useRouter } from 'next/router';

import { AnalyticsContext } from '@arrived/analytics';

const useAnalytics = () => {
  const router = useRouter();
  const { isLoading } = useContext(AnalyticsContext);

  useEffect(() => {
    if (!isLoading) {
      (window as any).rudderAnalytics?.page();

      const pageEvent = () => {
        (window as any).rudderAnalytics?.page();
      };

      router.events.on('routeChangeComplete', pageEvent);
      router.events.on('hashChangeComplete', pageEvent);

      return () => {
        router.events.off('routeChangeComplete', pageEvent);
        router.events.off('hashChangeComplete', pageEvent);
      };
    }
  }, [isLoading]);
};

export const NextAnalytics = ({ children }: { children: ReactNode }) => {
  useAnalytics();

  return <>{children}</>;
};
